module.exports = __webpack_public_path__ + "f1bc724d943b1a9a31852184008576e3.svg";